import {OwnershipStatus} from '../../components/OwnershipCard/OwnershipCard.models';
import {UserPlanStateEnum} from '@focusrite-novation/ampify-api';
import {Plugin} from './index';
import {MergedPlan} from './fetch-plans';
import {MergedPurchase} from './fetch-products';

export interface PluginOwnership extends Plugin {
  softwareId: string;
  state: OwnershipStatus;
  planId?: string;
  monthsRemaining?: number | undefined;
  nextBillingDate?: string | undefined;
}

const plansOwnershipStatus = (
  userPlanStatus: UserPlanStateEnum | undefined
): OwnershipStatus => {
  const statuses = new Map<UserPlanStateEnum, OwnershipStatus>([
    [UserPlanStateEnum.Active, OwnershipStatus.SUBSCRIBED],
    [UserPlanStateEnum.Canceled, OwnershipStatus.CANCELLED],
  ]);
  return (
    statuses.get(userPlanStatus as UserPlanStateEnum) || OwnershipStatus.NONE
  );
};

export const mapPlansList = (
  userPlans: MergedPlan[],
  plugins: Plugin[],
  loading?: boolean
) => {
  return plugins.map((plugin) => {
    const userPlan = userPlans.find(({softwareIds}) =>
      softwareIds.includes(plugin.softwareId)
    );
    return {
      ...plugin,
      planId: userPlan?.id || '',
      state: loading
        ? OwnershipStatus.LOADING
        : plansOwnershipStatus(userPlan?.state),
      monthsRemaining: userPlan?.remainingBillingCycles,
      nextBillingDate: userPlan?.nextBillingDate,
    };
  });
};

const getPurchaseStatus = (
  userPurchase?: MergedPurchase,
  loading?: boolean
) => {
  return loading
    ? OwnershipStatus.LOADING
    : userPurchase
    ? OwnershipStatus.OWNED
    : OwnershipStatus.NONE;
};

const mapPurchaseList = (
  userPurchases: MergedPurchase[],
  ownership: PluginOwnership[],
  loading?: boolean
) => {
  return ownership.map((plugin: PluginOwnership) => {
    const userPurchase = userPurchases.find(({softwareIds}) =>
      softwareIds.includes(plugin.softwareId)
    );

    if (userPurchase) {
      plugin.state = getPurchaseStatus(userPurchase, loading);
    }

    return plugin;
  });
};

export const mapProductsList = (
  userPlans: MergedPlan[],
  userPurchases: MergedPurchase[],
  plugins: Plugin[],
  loading?: boolean
): PluginOwnership[] => {
  const ownership = mapPlansList(userPlans, plugins, loading);
  return mapPurchaseList(userPurchases, ownership, loading);
};
